import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { THEME_SETTINGS } from "@theme-settings";
import { useRootAppStore } from "@hooks";
import classNames from "classnames";
import { Bet } from "@models";

export default observer(function ShareBetSlipButton(props: {
	bet: Bet;
	isMini?: boolean;
	isIconOnly?: boolean;
}) {
	const { t } = useTranslation("mybets");
	const store = useRootAppStore().myBetsViewStore;

	if (!THEME_SETTINGS.features.isBetSlipShareEnabled) {
		return null;
	}

	if (store == null) {
		return null;
	}

	const btnClasses = classNames(
		"card--bet__btn card--bet__btn--share btn",
		{
			"btn--sml": !props.isIconOnly,
			"btn--square btn--square--xsml": props.isIconOnly,
			"btn--xsml": props.isMini,
		},
		"btn--primary--subtle btn--icon"
	);

	const iconClasses = classNames(
		"u-icon",
		{
			"u-icon--sml": !props.isIconOnly,
			"u-icon--tny": props.isIconOnly || props.isMini,
		},
		"u-icon--share"
	);

	return (
		<button
			type="button"
			className={btnClasses}
			onClick={() => {
				store.shareBetSlipStore.showPopup(props.bet);
			}}
			title={t<string>("SHARE.BUTTON_LABEL")}
		>
			<i className={iconClasses} />
			{!props.isMini ? <>{t("SHARE.BUTTON_LABEL")}</> : null}
		</button>
	);
});
